<template>
  <Container type="card-full" drankColor>
    <div class="box">
      <div class="l">
        <div style="display: flex; aligin-items: center">
          <div class="item" style="margin-right:40px;">
            <span class="filed">项目编号: </span>
            <span class="filed1">{{ project.projectcode }}</span>
          </div>
          <div class="item" style="margin-left:10px;">
            <span class="filed">评审方法: </span>
            <span class="filed1">
              {{ project.prsflgdesc }}——{{ project.projectdoneflgdesc }}——{{ project.projectpricecomputebasisdesc
              }}<span v-if="project.projectaveragepriceshift">——平均价浮动率:{{ project.projectaveragepriceshift }}</span>
            </span>
          </div>
        </div>
        <div class="item"><span class="filed">项目名称:</span><span class="filed1">{{ project.projectname }}</span></div>
        <div style="display: flex; aligin-items: center">
          <div class="item">
            <span class="filed">起拍价格: </span>
            <span class="filed1">{{ project.projectlimitamt | qfwVal }}(
              <amount :money="String(project.projectlimitamt)" v-if="project.projectlimitamt" />)
            </span>
          </div>
          <div class="item" style="margin-left:10px;">
            <span class="filed1">报价{{ +project.projecthsflg === 1 ? '含税' : '不含税' }}</span>
          </div>
        </div>
        <div style="display: flex; aligin-items: center">
          <div class="item">
            <span class="filed">梯度金额: </span>
            <span class="filed1">{{ project.projectgradientamt | qfwVal }}(
              <amount :money="String(project.projectgradientamt)" v-if="project.projectgradientamt" />)
            </span>
          </div>
          <!-- <div class="item" style="margin-left:10px;">
            <span class="filed1">最新举牌后<span class="red">{{ project.prsnmin }}</span>分钟,如果无举牌,自动结束,有则时间顺延</span>
          </div> -->
        </div>
      </div>
      <div class="r">
        <div style="width: 280px">
          <div><span class="filed">开始时间: </span><span class="filed1">{{ project.prsbjbegtime | newDateTime }}</span>
          </div>
          <div><span class="filed time">当前时间: </span><span class="filed1 time">{{ sysDate }}</span></div>
          <div><span class="filed">截止时间: </span><span class="filed1">{{ project.prsbjendtime | newDateTime }}</span>
          </div>
        </div>
        <div class="btn">
          <el-button type="danger" size="medium" @click="quit" icon="el-icon-close">退出大厅</el-button>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="m-r-15">
        <span class="filed">项目员</span>
        <span class="filed1" v-if="project.projecttype === 2">{{ project.hostusercode | keepSecret }}
          <!-- {{ msgList.isOnline >= 0 ? "[在线]" : "[不在线]" }} -->
        </span>
        <span class="filed1" v-else>{{ project.hostusercode | keepSecret }}
          <!-- {{ msgList.isOnline >= 0 ? "[在线]" : "[不在线]" }} -->
        </span>
        <!-- <span class="filed1" >[在线]</span> -->
      </div>
      <!-- 按钮组 -->
      <div v-if="showZCRbtn">
        <el-popover placement="top" width="300" v-model="showfy">
          <p>请输入发言内容</p>
          <el-input style="margin:0 0 20px 0" v-model="moderatorSpeaksMsg" placeholder="请输入内容"></el-input>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="showfy = false">取消</el-button>
            <el-button type="primary" size="mini" @click="moderatorSpeaks">确定</el-button>
          </div>
          <el-button type="primary" slot="reference" size="small" class="m-r-15" :disabled="btndisabled.fyBoolean">发言
          </el-button>
        </el-popover>
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.startBoolean" @click="startJP">启动报价
        </el-button>
      </div>
      <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.ylbBoolean" @click="showBJvuew">
        {{ bjviewName }}</el-button>
      <div v-if="showZCRbtn">
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.endBoolean" @click="endJP">结束报价
        </el-button>
      </div>
      <div class="time-down" v-if="!timeOut">
        <div class="t">
          <i class="el-icon-time"></i>
          <div>离竞拍开始还剩</div>
        </div>
        <div class="back">{{ hourNum }}</div>
        <div class="date">时</div>
        <div class="back">{{ minuteNum }}</div>
        <div class="date">分</div>
        <div class="back">{{ secondNum }}</div>
        <div class="date">秒</div>
      </div>
      <div class="time-down" v-else>
        <div class="dataing">{{ this.project.projectjkactualendtime === null ? '网上报价正在进行' : '举牌竞拍已结束，请退出大厅' }}</div>
      </div>
    </div>
    <div class="desc-box">
      <div class="bg-white txt">
        <i class="icon el-icon-s-custom"></i>
        <span>在线用户</span>
      </div>
      <div class="content bg-white" style="flex-direction: row;font-size: 14px;">
        <el-button type="primary" v-if="showGYSbtn" @click="showJPbox" :disabled="btndisabled.JPBoolean"
          :loading="jpBtnloading" class="mr10">举牌出价</el-button>
        <div class="m-r-15" v-if="!newInfo">
          <span style="font-weight: bold">项目{{ +this.project.prsflg === 4 ? '底价' : '预算' }}为¥{{ project.projectlimitamt |
              qfwVal
          }}元，每个梯度{{ +this.project.prsflg === 4 ? '加' : '减' }}价为¥{{ project.projectgradientamt | qfwVal }}元</span>
        </div>
        <div class="m-r-15" v-else>
          <div style="display:flex;" v-show="!JPtimeOut">
            <div style="margin-right:10px;">
              <span style="font-weight: bold;color:#000;">最新举牌价: </span> {{ newInfo.pbtlowprice | qfwVal }}元
            </div>

            <!-- <div class="autoTime">
              <div>离竞拍报价自动结束还剩 </div>
              <div class="back">{{ autominuteNum }}</div>
              <div class="date">分</div>
              <div class="back">{{ autosecondNum }}</div>
              <div class="date">秒</div>
            </div> -->
          </div>
          <div v-show="JPtimeOut" style="font-Weight:bold;color:red;">
            竞拍结束
          </div>
        </div>
      </div>
      <div class="bg-white txt">
        报价屏
      </div>
    </div>
    <div class="desc-box">
      <div class="message-list bg-white ">
        <div class="block">
          <span class="title">
            <i class="icon el-icon-s-custom"></i> <span>代理人</span>
          </span>
          <div v-for="(item, index) in msgList.onLineUser.dlr" :key="index">{{ item.usercode }}</div>
        </div>
        <div class="block">
          <span class="title">
            <i class="icon el-icon-s-custom"></i> <span>采购人</span>
          </span>
          <div v-for="(item, index) in msgList.onLineUser.cgr" :key="index">{{ item.usercode }}</div>
        </div>
        <div class="block" v-if="$store.getters.loginUser.comtype !== 3">
          <span class="title"><i class="icon el-icon-s-custom"></i> <span>供应商</span></span>
          <div v-for="(item, index) in msgList.onLineUser.gys" :key="index">{{ item.usercode }}</div>
        </div>
      </div>
      <div class="message-content bg-white " ref="msg-content">
        <div v-for="(item, index) in msgList.common" class="item" :key="index">{{ item.time }}: {{ item.msg }}</div>
      </div>
      <div class="message-list bg-white mss-bjp">
        <div class="item" v-for="(item, index) in bjscreen" :key="index">
          <div>第{{ bjscreen.length - index }}次举牌{{ item.pbramt | qfwVal }}元
            <!-- (<amount :money="String(item.pbramt)" v-if="item.pbramt"/>) -->
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div>
        <span class="filed">竞拍必读:</span>
        <div v-html="cosInfo.cosjpzxbjreadinfo" v-if="+project.prsflg === 4"></div>
        <div v-html="cosInfo.cosjpfxbjreadinfo" v-if="+project.prsflg === 5"></div>
      </div>
    </div>
    <el-dialog title="举牌竞拍报价器" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-divider>【举牌出价】</el-divider>
      <div class="el-box">
        <div style="display: flex;">
          <div class="item" style="margin-right:40px;">
            <span class="filed">项目编号: </span>
            <span class="filed1">{{ project.projectcode }}</span>
          </div>
          <div class="item" style="margin-left:10px;">
            <span class="filed">评审方法: </span>
            <span class="filed1">
              {{ project.projectdoneflgdesc }}——{{ project.projectpricecomputebasisdesc }}<span
                v-if="project.projectaveragepriceshift">——平均价浮动率:{{ project.projectaveragepriceshift }}</span>
            </span>
          </div>
        </div>
        <div class="item"><span class="filed">项目名称:</span><span class="filed1">{{ project.projectname }}</span></div>
        <div style="display: flex; aligin-items: center">
          <div class="item">
            <span class="filed">起拍价格: </span>
            <span class="filed1">{{ project.projectlimitamt | qfwVal }}(
              <amount :money="String(project.projectlimitamt)" v-if="project.projectlimitamt" />)
            </span>
          </div>
          <div class="item" style="margin-left:10px;">
            <span class="filed1">报价{{ +project.projecthsflg === 1 ? '含税' : '不含税' }}</span>
          </div>
        </div>
        <div style="display: flex; aligin-items: center">
          <div class="item">
            <span class="filed">梯度金额: </span>
            <span class="filed1">{{ project.projectgradientamt | qfwVal }}(
              <amount :money="String(project.projectgradientamt)" v-if="project.projectgradientamt" />)
            </span>
          </div>
          <!-- <div class="item" style="margin-left:10px;">
            <span class="filed1">最新举牌后<span class="red">{{ project.prsnmin }}</span>分钟,如果无举牌,自动结束,有则时间顺延</span>
          </div> -->
        </div>
      </div>
      <el-divider>【最新出价】</el-divider>
      <div class="el-box">
        <div class="red" v-if="newInfo">
          <span>最新出价金额 ¥ {{ newInfo.pbtlowprice | qfwVal }}元</span> <span>出价时间：{{ newInfo.pbtbtime | newDateTime
          }}</span>
          <span>出价人：{{ newInfo.usercode | keepSecret }}</span>
        </div>
        <div class="red" v-else>
          <span style="font-weight: bold">项目{{ +this.project.prsflg === 4 ? '底价' : '预算' }}为¥{{ project.projectlimitamt |
              qfwVal
          }}元，每个梯度{{ +this.project.prsflg === 4 ? '加' : '减' }}价为¥{{ project.projectgradientamt | qfwVal }}元</span>
        </div>
      </div>
      <el-divider>【本次出价】</el-divider>
      <div class="zxcj">
        <div class="zxcj-box">
          <span>{{ +project.prsflg === 4 ? '加' : '减' }}</span>
          <!-- <el-input-number v-model="num" :min="1" @change="handleChange"></el-input-number> -->
          <div class="bjq-numx">
            <el-button class="bjq-jian" @click="subnum">-</el-button>
            <div class="bjq-shu">{{ num }}</div>
            <el-button class="bjq-jia" @click="addnum">+</el-button>
          </div>
          <span style="margin-left: 10px" v-if="+biddingPrice > 0">梯度，即报价金额： ¥ {{ String(biddingPrice) | qfwVal }} 【
            <amount :money="String(biddingPrice)" v-if="biddingPrice" />】元
          </span>
          <span style="margin-left: 10px" v-else>梯度，金额不能小于等于0</span>
        </div>
        <div>
          <el-button type="primary" @click="saveJPPrice">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="报价一览表" :visible.sync="dialogView" width="80%" :before-close="handleClose">
      <div id="bjview-box" style="width:100%;">
        <div class="bjview-box" style="margin:0 auto;">
          <div class="bjview-header">
            <div class="bjview-index">
              序号
            </div>
            <div class="bjview-name">
              竞拍单位
            </div>
            <div class="bjview-list header-jl">
              举牌价
            </div>
            <div class="bjview-list-r header-jl-r">
              举牌时间
            </div>
            <div class="bjview-name">
              举牌人确认
            </div>
          </div>
          <div v-for="(i, index) in schedulList" :key="i.pbrcomid" class="bjview-item">
            <div class="bjview-index">
              <div class="bjview-indexitem">{{ index + 1 }}</div>
            </div>
            <div class="bjview-name">
              <div class="bjview-comname">{{ i[0].comfullname }}</div>
            </div>
            <div class="bjview-list">
              <div v-for="(j, index)  in i" :key="index" class="bjview-list-item">
                <div class="item-index">第{{ j.pbtseq }}次</div>
                <div class="item-price">￥{{ j.pbramt | qfwVal }}元(
                  <amount :money="String(j.pbramt)" v-if="j.pbramt" />)
                </div>
              </div>
            </div>
            <div class="bjview-list-r">
              <div v-for="j in i" :key="j.pbrid" class="bjview-list-item">
                <div class="item-index">{{ j.pbrtime | newDate }}</div>
              </div>
            </div>
            <div class="bjview-name">
              <div class="bjview-red" v-if="!btndisabled.confirmQ && i[0].pbrcomid === $store.getters.loginUser.comid">
                <el-button type="primary" size="small" class="m-r-15" @click.stop="confirmQuotation">确认报价</el-button>
              </div>
              <div v-else class="bjview-red">
                <!-- <div v-if="i[0].psuamtcommituserid && +i[0].psuamtcommituserid !== +i[0].psuuserid">系统自动确认</div> -->
                {{ i[0].psuname }} {{ i[0].psuamtcommittime | newDateTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bjview-button" v-if="this.$store.getters.loginUser.comtype !== 3">
        <el-button type="primary" class="button-i" @click.stop="lodopPrint">打印</el-button>
      </div>
    </el-dialog>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import config from '../../assets/config'
import uploadBtn from '../common/uploadBtn'
import amount from '../common/amount'
import common from '@/mixin/common'
import io from 'socket.io-client'
import moment from 'moment'
import _ from 'lodash'
import dayjs from 'dayjs'
// import data from '../component/data'
import { mapGetters } from 'vuex'
import { clear } from 'xe-utils/methods'
let LODOP
// import { isFormData } from 'xe-utils/methods'
// import BetterScroll from 'better-scroll'
/* eslint-disable */
export default {
  name: "auctionHall",
  mixins: [common],
  data() {
    return {
      showfy: false,
      moderatorSpeaksMsg: '',//发言内容
      project: {},
      num: 1,
      psuid: this.$route.params.psuid,
      cosInfo: [],
      append: { appendurl: '', appendfilename: '' },
      msgList: {
        common: [],
        onLineUser: [],
        bjview: [],     //报价屏
        bjuserList: [],//报价一览表数据
        isOnline: -1 //-1为不在线
      },
      interval: null,
      timeInterval: null,
      days: '0',
      hours: '0',
      minutes: '0',
      seconds: '0',
      autominutes: '0',
      autoseconds: '0',
      date: '',
      psuNum: 0,   //报名人数
      btnLoading: false,
      dialogVisible: false,
      dialogView: false,
      showGYSbtn: false, //供应商按钮
      showZCRbtn: false, //主持人按钮
      jpBtnloading: false,
      newInfo: {},//最新的报价信息
      newPrice: 0, //当前的报价金额
      schedulList: [],
      pbrList: [],
      bjscreen: [],
      btndisabled: {
        startBoolean: true,
        JPBoolean: true,
        fyBoolean: false,
        ylbBoolean: true,
        endBoolean: false,
        confirmQ: false
      }
    }
  },
  destroyed() {
    clearInterval(this.autoSetInterval)
    if (this.isauctionHallClose === 3) {
      // this.$store.commit('close_tab', {routeName: this.$route.name, vm:this, newRouteName:''})
      this._clearData()
    }
    this.socket.close()
  },
  async mounted() {
    // await this.getProjectById()
    this.$nextTick(async () => {
      await this.getPbrAllList()
      await this.init()
      await this.getcositemList()
      await this.getPsuByprojectId()  //获取应到人数
      await this.getPbrList()
      await this.getProjectSchedulList()
      this.sokcet()

      this.timeInterval = setInterval(() => {
        this.date && (this.date = new Date(this.date).getTime() + 1000)
      }, 1000)
      if (this.cosInfo) {
        clearInterval(this.autoSetInterval)
        this._emitbj(true, false)
      }
    })
    window.addEventListener('beforeunload', () => {
      this._clearData()
    })
  },
  watch: {
    async timeEnd(val) {
      if (val.autominuteNum === '00' && val.autosecondNum === '00') {
        this.jpBtnloading = true
        setTimeout(async () => {
          this.updatePbt().then(async () => {
            await this.fromOperate('getPbrAllList')
            this.jpBtnloading = false
          })
        }, 1000)
      }
    }
  },
  filters: {
    newDateTime(val) {
      return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    formatComdify(value) {
      return utils.comdify(value)
    },
    keepSecret(num) {
      var mobile = String(num)
      var reg = /^(\d{3})\d{4}(\d{4})$/
      return mobile.replace(reg, '$1****$2')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4)
        }
        else {
          return val
        }
      }
      return val
    },
    keepSecret(num) {
      var mobile = String(num)
      var reg = /^(\d{3})\d{4}(\d{4})$/
      return mobile.replace(reg, '$1****$2')
    },
  },
  components: { uploadBtn, amount },
  computed: {
    ...mapGetters(['tabRoutes', 'loginUser', 'isauctionHallClose']),
    timeEnd() {
      let autominuteNum = this.autominuteNum
      let autosecondNum = this.autosecondNum
      return {
        autominuteNum, autosecondNum
      }
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr
    },
    dayNum() {
      if (this.days < 10) return '0' + this.days
      return this.days
    },
    hourNum() {
      if (this.hours < 10) return '0' + this.hours
      return this.hours
    },
    minuteNum() {
      if (this.minutes < 10) return '0' + this.minutes
      return this.minutes
    },
    secondNum() {
      if (this.seconds < 10) return '0' + this.seconds
      return this.seconds
    },
    autominuteNum() {
      if (this.autominutes < 10) return '0' + this.autominutes
      return this.autominutes
    },
    autosecondNum() {
      if (this.autoseconds < 10) return '0' + this.autoseconds
      return this.autoseconds
    },
    timeOut() {
      return this.hourNum === '00' && this.minuteNum === '00' && this.secondNum === '00'
    },
    JPtimeOut() {
      return this.autominuteNum === '00' && this.autosecondNum === '00'
    },
    sysDate() {
      return utils.formatterDate(new Date(this.date), 'yyyy-MM-dd HH:mm:ss')
    },
    biddingPrice() {
      if (+this.project.prsflg === 4) {
        return (Number(this.num * this.project.projectgradientamt) * 100 + Number(this.newPrice) * 100) / 100
      }
      if (+this.project.prsflg === 5) {
        return (Number(this.newPrice) * 100 - Number(this.num * this.project.projectgradientamt) * 100) / 100
      }
    },
    bjviewName() {
      if (this.$store.getters.loginUser.comtype === 3) {
        return '报价一览表'
      }
      else {
        return '报价一览表'
      }
    },
  },
  methods: {
    async lodopPrint() {  //打印
      let { href } = this.$router.resolve({ name: 'pbrCenterDY', query: { projectid: this.project.projectid } })
      window.open(href, '_blank')
    },
    async getcositemList() {
      this.loading = true

      let res = await request({
        method: 'get',
        url: '/ywgl/cos/getCosbyid',
        params: { cosid: this.$store.getters.loginUser.cosid }
      })

      this.cosInfo = res[0]

      this.loading = false
    },
    async getProjectById() {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getProjectById',
        params: { projectid: this.$route.params.projectid }
      })
      this.project = res[0]
    },
    async startJP() {
      if (moment(new Date()).isBefore(this.project.prsbjbegtime)) {
        this.$message.warning('未到竞拍开始时间')
        return
      }
      if (moment(new Date()).isAfter(this.project.prsbjendtime)) {
        this.$message.warning('竞拍已结束')
        return
      }
      this.loading = true
      let model = {}
      model.projectid = this.project.projectid
      model.projecthostuserid = this.$store.getters.loginUser.userid
      let res = await request({
        url: '/xmgl/pbr/startJJ',
        method: "post",
        data: model
      })
      if (+res.issuccess === 1) {
        this.Speaks(`本项目有效报名供应商${this.psuNum}人实到${this.msgList.onLineUser.gys.length}人；
                      采购人${this.msgList.onLineUser.cgr.length}人；
                      代理机构${this.msgList.onLineUser.dlr.length}人
                      `)
        this.fromOperate('getPbrAllList')
        this._emitbj()
      }
      this.loading = false

    },
    async endJP() {
      this.loading = true
      let Obj = {}
      Obj.projectid = this.project.projectid

      //查询还有几位供应商未确认报价
      let num = await request({
        url: '/xmgl/pbr/unconfirmed',
        method: "get",
        params: Obj
      })
      if (num) {
        this.$confirm(`还有${num}位供应商未确认，是否强制确认`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let from = {}
          from.projectid = this.project.projectid
          from.prsbjtimes = this.project.prsbjtimes
          from.psuamtcommituserid = this.loginUser.userid
          let res = await request({
            url: '/xmgl/pbr/endJP',
            method: "post",
            data: from
          })
          if (res.issuccess === 1) {
            this.$message.success('竞拍结束')
            this.Speaks(`本项目网上报价结束，请退出大厅，等候评审结果发布。`)
            this.fromOperate('getPbrAllList')
          } else {
            this.$message.error('失败')
          }
        }).catch(() => { })
      }
      else {
        this.$confirm(`是否结束竞拍`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let from = {}
          from.projectid = this.project.projectid
          let res = await request({
            url: '/xmgl/pbr/endJJ',
            method: "post",
            data: from
          })
          if (res.issuccess === 1) {
            this.$message.success('竞拍结束')
            this.Speaks(`本项目网上报价结束，请退出大厅，等候评审结果发布。`)
            this.fromOperate('getPbrAllList')
          } else {
            this.$message.error('失败')
          }
        }).catch(() => { })
      }
      this.loading = false
    },
    async init() {
      this.date = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      this.date = new Date(this.date).getTime()
      this.showZCRbtn = this.$store.getters.loginUser.comtype !== 3 && +this.project.projectcuserid === +this.$store.getters.loginUser.userid ? true : false
      this.showGYSbtn = this.$store.getters.loginUser.comtype === 3
      this.pbrList = []
    },
    handleClose() {
      this.num = 1
      this.dialogVisible = false
      this.dialogView = false
    },
    async showBJvuew() {
      this.dialogView = true
      await this.getSchedulList()
      await this.getPbrList()
    },
    async autoTimeDown(time = 0, now) {
      let timeDown = 3
      this.autodate = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      // this.autodate = new Date(this.autodate).getTime() + timeDown * 61 * 1000
      if (time > 0) {
        this.autodate = new Date(time)
        let that = this
        let interVal = () => {
          return setInterval(() => {
            now += 1 * 1000
            if (moment(new Date(now)).isAfter(moment(new Date(time)))) {
              clearInterval(that.autoSetInterval)
            }
            let dur = moment.duration(moment(new Date(time)) - moment(new Date(now)), 'ms')
           
            if (dur.get('minutes') >= 0) {
              that.autominutes = dur.get('minutes')
              if (dur.get('hours') >= 0) {
                that.autominutes = dur.get('hours') * 60 + that.autominutes
              }
              
            }
            if (dur.get('seconds') >= 0) {
              that.autoseconds = dur.get('seconds')
            }
          }, 1000)
        }
        if (!moment(new Date(now)).isAfter(moment(new Date(time)))) {
          this.autoSetInterval = interVal()
        }
      }
    },
    timeDown() {
      this.timeSetInterval = setInterval(() => {
        if (moment(new Date(this.project.prsbjbegtime)).isBefore(moment())) {
          clearInterval(this.timeSetInterval)
        }
        let dur = moment.duration(moment(this.project.prsbjbegtime) - moment(), 'ms')
        this.days = dur.get('days')
        this.hours = dur.get('hours')
        this.minutes = dur.get('minutes')
        this.seconds = dur.get('seconds')
      }, 1000);
    },
    _clearData() {
      this.socket.emit('quit', {
        id: this.loginUser.userid,
        usercode: this.loginUser.usercode,
        projectcode: 'auction' + this.project.projectcode,
        usertype: this.loginUser.comtype,
      })
      this.socket.on('disconnect', function () { })
      clearInterval(this.interval)
      this.interval = null
      clearInterval(this.timeInterval)
      this.timeInterval = null
      clearInterval(this.autoSetInterval)
      this.$store.commit('SET_ISAUCTIONHALLCLOSE', 0)
    },
    fromOperate(m) {
      this.socket.emit('fromOperate', {
        id: this.loginUser.userid,
        projectcode: 'auction' + this.project.projectcode,
        operate: {
          projectcode: 'auction' + this.project.projectcode,
          m: m,
          type: 'method'
        }
      })
    },
    quit() {
      this.$confirm('是否退出竞拍大厅?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('SET_ISAUCTIONHALLCLOSE', 3)
        this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: '' })
      }).catch(() => {
      })
    },
    time() {
      let that = this
      this.interval = setInterval(() => {
        if (moment(this.project.prsbjendtime).isBefore(moment())) {
          clearInterval(that.interval)
          that.interval = null
          this.sokcet()
          this.fromEmit('系统提醒,正式报价开始了')
        }
        let dur = moment.duration(moment(this.project.prsbjendtime) - moment(), 'ms');
        this.days = dur.get('days')
        this.hours = dur.get('hours')
        this.minutes = dur.get('minutes')
        this.seconds = dur.get('seconds')
      }, 1000)
    },
    sokcet() {
      // if (!this.socket) this.socket = io(config.baseUrl)
      this.socket = io(config.baseUrl)
      let obj = {
        id: this.loginUser.userid,
        usercode: this.loginUser.usercode,
        projectcode: 'auction' + this.project.projectcode,
        usertype: this.loginUser.comtype,
        isCloseStatus: this.isauctionHallClose
      }
      this.isauctionHallClose === 2 && (obj.firstTime = moment(new Date()))
      this.socket.emit('onProject', obj)
      this.isauctionHallClose === 1 && this.socket.emit('getCacheMsg', {
        projectcode: this.project.projectcode,
        id: this.loginUser.userid
      })
      this.socket.on('msg', (data) => {
        if (data.projectcode == 'auction' + this.project.projectcode) {
          if (data.type == 'time') {
            clearInterval(this.autoSetInterval)
            this.now = data.now
            if (data.time) {
              this.autoTimeDown(data.time, data.now)
            }
          }
          if (data.common) {
            !this.msgList['common'] && (this.msgList['common'] = [])
            if (Array.isArray(data.common)) this.msgList['common'] = data.common
            else this.msgList['common'].unshift(data.common)
          }
          if (data.lineUser) {
            this.msgList['onLineUser'] = data.lineUser
            if (+this.project.projecttype === 2) {
              this.msgList.isOnline = data.lineUser.all.findIndex(item => {
                return item.userid === Number(this.project.projectpuserid)
              })
            }
            else {
              this.msgList.isOnline = data.lineUser.all.findIndex(item => {
                return item.userid === Number(this.project.projectauserid)
              })
            }
          }
          if (data.type === 'method') {
            this[data.m] && this[data.m].bind(this)()
          }
        }
      })
    },
    _emitbj(isemitUser, isUpdateTime = true) {
      this.socket.emit('emitbj', {
        projectcode: 'auction' + this.project.projectcode,
        userid: isemitUser ? this.loginUser.userid : '',
        isUpdateTime,
        projectinfo: {
          prsnmin: this.project.prsnmin
        }
      })
    },
    telSecret(num) {
      var mobile = String(num)
      var reg = /^(\d{3})\d{4}(\d{4})$/
      return mobile.replace(reg, '$1****$2')
    },
    //SLint: Strings must use singlequote. (quotes
    // 1 = 系统消息
    fromEmit(msg, type) {
      this.sokcet()
      this.socket.emit('fromEmit', {
        id: this.$store.getters.loginUser.userid,
        msg,
        type,
        projectcode: 'auction' + this.project.projectcode
      })
    },
    close() {
      this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: 'projectPbrIndex' })
    },
    moderatorSpeaks() {
      this.socket.emit('fromEmit', {
        id: this.loginUser.userid,
        projectcode: 'auction' + this.project.projectcode,
        msg: {
          projectcode: 'auction' + this.project.projectcode,
          common: {
            msg: this.moderatorSpeaksMsg
          }
        }
      })
      this.moderatorSpeaksMsg = ''
      this.showfy = false
    },
    //自动发言
    Speaks(msg) {
      this.socket.emit('fromEmit', {
        id: this.loginUser.userid,
        projectcode: 'auction' + this.project.projectcode,
        msg: {
          projectcode: 'auction' + this.project.projectcode,
          common: {
            msg
          }
        }
      })
    },
    showJPbox() {
      this.newPrice = _.cloneDeep(this.newInfo ? this.newInfo.pbtlowprice : this.project.projectlimitamt)
      this.dialogVisible = true
    },
    //判断按钮是否可以点击——
    async getPbrAllList() {
      this.loading = true
      await this.getProjectById()
      this.newInfo = await request({
        url: '/xmgl/pbr/getJPPrice',
        method: "get",
        params: { projectid: this.$route.params.projectid }
      })
      if (this.project.projectjkactualbegtime === null) {//竞拍没开始
        this.btndisabled.startBoolean = false
        this.btndisabled.ylbBoolean = true
        this.btndisabled.endBoolean = true
        this.btndisabled.JPBoolean = true
      }
      if (this.project.projectjkactualbegtime !== null && this.project.projectjkactualendtime === null) {
        this.btndisabled.startBoolean = true
        this.btndisabled.endBoolean = false
        this.btndisabled.ylbBoolean = true
        this.btndisabled.JPBoolean = false
      }
      if (this.newInfo) {

        if (this.newInfo.pbtsatus) {
          this.btndisabled.startBoolean = true
          this.btndisabled.endBoolean = false
          this.btndisabled.ylbBoolean = false
          this.btndisabled.JPBoolean = true
        } else {
          this.btndisabled.startBoolean = true
          this.btndisabled.endBoolean = false
          this.btndisabled.ylbBoolean = true
          this.btndisabled.JPBoolean = false
        }
      }
      if (this.project.projectjkactualendtime !== null) {//竞拍结束
        this.btndisabled.startBoolean = true
        this.btndisabled.endBoolean = true
        this.btndisabled.fyBoolean = true
        this.btndisabled.ylbBoolean = false
        this.btndisabled.JPBoolean = true
      }
      this.loading = false
    },
    //获取最新的价格
    async getLatestPrice() {
      let form = {}
      form.projectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getJPPrice',
        method: "get",
        params: form
      })
      this.newInfo = res
    },
    //一览表
    async getSchedulList() {
      let form = {}
      form.projectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getSchedulList',
        method: "get",
        params: form
      })
      this.schedulList = res
      if (this.psuid) {
        await this.getPusInfo()
        if (this.psuInfo.psuamtcommituserid) {
          this.btndisabled.confirmQ = true
        }
      }
    },
    //举牌出价结束
    async updatePbt() {
      let form = {}
      form.projectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/updatePbt',
        method: "post",
        data: form
      })
    },
    //获取项目所有报价
    async getProjectSchedulList() {
      let form = {}
      form.projectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getProjectSchedulList',
        method: "get",
        params: form
      })
      this.bjscreen = res
    },
    //获取报名人数
    async getPsuByprojectId() {
      let res = await request({
        url: '/xmgl/pbr/getPsuByprojectId',
        method: "get",
        params: { projectid: this.project.projectid }
      })
      this.psuNum = res.count
    },
    async saveJPPrice() {//举牌出价

      if (+this.biddingPrice <= 0) {
        this.$message.warning('本次举牌后价格小于0，系统不接受本次举牌！')
        return
      }
      let form = {}
      form.userid = this.loginUser.userid
      form.comid = this.loginUser.comid
      form.pbramt = this.biddingPrice //竞拍金额
      form.projectid = this.project.projectid
      form.pbramt = this.biddingPrice
      form.projectlimitamt = this.project.projectlimitamt
      form.prsflg = this.project.prsflg
      const iSprojectdelaypricepermite = this.project.projectdelaypricepermite === 0 ? true: false
      console.log(this.project.projectdelaypricepermite)
      if (!iSprojectdelaypricepermite) {
        let date = await request({
          method: 'get',
          url: 'xtgl/sysdata'
        })
        if (dayjs(date).isAfter(dayjs(this.project.prsbjendtime))) {
          this.$message.warning('当前时间已超过报价截止时间,不允许提交报价')
          return
        }
      }
      let res = await request({
        url: '/xmgl/pbr/saveJPPrice',
        method: "post",
        data: form
      })
      if (+res.issuccess === 1) {
        this.num = 1
        await this.fromOperate('getProjectSchedulList')
        this._emitbj()
        let usercode = this.telSecret(this.loginUser.usercode)
        this.Speaks(`${usercode}举牌出价`)
        this.$message.success(`${res.msg}`)
      } else if (+res.issuccess === 2) {
        this.$message.warning(`${res.msg}`)
      } else {
        this.$message.warning(`${res.msg}`)
      }
      await this.fromOperate('getLatestPrice')
      this.dialogVisible = false
    },
    async getPusInfo() {//获取报名信息
      this.loading = true

      let res = await request({
        method: 'get',
        url: '/xmgl/project/getpsubyid',
        params: { psuid: this.$route.params.psuid }
      })

      this.psuInfo = res[0]
      this.loading = false
    },
    async getPbrList() {//获取自己的所有报价
      this.loading = true
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getPbrList',
        params: { projectid: this.project.projectid, comid: this.$store.getters.loginUser.comid, orderbyFlg: 'desc' }
      })
      this.pbrList = res
      this.loading = false
    },
    //查找所有轮次
    //确认报价
    async confirmQuotation() {//确认报价
      this.loading = true
      let model = {}
      model.psuid = this.$route.params.psuid
      model.projectid = this.project.projectid
      model.prsbjtimes = this.project.prsbjtimes
      model.psuamt = this.pbrList[0].pbramt
      model.pbrtime = this.pbrList[0].pbrtime
      model.psuamtcommituserid = this.$store.getters.loginUser.userid
      let data = await request({
        url: '/xmgl/pbr/confirmQuotation',
        method: "post",
        data: model
      })
      if (data.issuccess === 1) {
        this.$message.success('确认成功')
        this.fromOperate('getPbrAllList')
        this.dialogView = false
        return
      }
      this.loading = false
    },
    handleChange(e) {
      console.log('-------e---------', e);
    },
    addnum() {
      this.num++
    },
    subnum() {
      if (this.num > 1) {
        this.num--
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.linkstyle {
  color: #2f74ff;
  font-size: 13px;
  margin-right: 20px;
  cursor: pointer;
}

.fliename {
  cursor: pointer;
  color: #2f74ff;
}

.box {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 5px;
  box-sizing: border-box;
  padding: 10px;
  color: #828282;
}

.box .l {
  flex: 1
}

.box .r {
  width: 380px;
  text-align: right;
  display: flex;
  align-items: center;
}

.box .r .btn {
  flex: 1;
  margin-left: 20px;
}

.box .item {
  display: flex;
  align-items: center;
}

.filed,
.filed1 {
  font-size: 14px;
  line-height: 30px;
}

.filed {
  width: 70px;
}

.filed1 {
  flex: 1
}

.m-r-15 {
  margin-right: 15px
}

.tip {
  color: red;
  font-size: 14px;
  font-weight: bold;
  margin-left: 15px;
}

.desc-box {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 5px;
  color: #828282;
}

.desc-box .content {
  width: 60%;
  display: flex;
  align-items: center;
  margin: 0 5px;
  height: 70px;
  box-sizing: border-box;
  padding: 10px;
}

.desc-box .txt {
  height: 70px;
  width: 20%;
  text-align: center;
  line-height: 70px;
}

.message-list {
  width: 20%;
  overflow: auto;
  height: 300px;
  box-sizing: border-box;
  padding: 15px;
}

.message-list .block {
  margin-bottom: 8px;
}

.message-list .title {
  color: #828282;
  font-weight: bold
}

.message-list .item {
  color: #828282;
  font-size: 14px;
  margin-bottom: 4px;
}

.message-content {
  width: 60%;
  overflow: auto;
  height: 300px;
  margin: 0 5px;
  box-sizing: border-box;
  padding: 12px;
}

.message-content .item {
  color: #828282;
  font-size: 14px;
  margin-bottom: 5px;
}

.bg-white {
  background: #fff;
}

ul li {
  font-size: 14px;
  line-height: 32px;
}

.time {
  color: rgb(30, 63, 142);
  font-weight: bold;
}

.boxitem {
  display: flex;
  margin: 10px 10px;
}

.itemname {
  margin-right: 20px;
}

.boxitembtn {
  overflow: hidden;
}

.itembtn {
  float: right;
}


.bjview-box {
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.bjview-header {
  display: flex;
  // justify-content: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
}

.bjview-index {
  text-align: center;
  width: 50px;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-item {
  display: flex;
  line-height: 35px;
}

.bjview-name {
  overflow: hidden;
  width: 152px;

  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name:last-child {
  border-right: none;
}

.header-jl {
  border-bottom: 1px solid #e8eaec;
}

.header-jl-r {
  border-right: 1px solid #e8eaec;
}

.bjview-list {
  flex: 5;
  -webkit-box-flex: 5;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-list-r {
  flex: 3;
  -webkit-box-flex: 3;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  // border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-list-item {
  display: flex;
  padding-left: 10px;
  border-bottom: 1px solid #e8eaec;
  // height:100%;
}

.bjview-list-item:last-child {

  height: 100%;
}

.item-index {
  // width: 150px;
  flex: 2;
  -webkit-box-flex: 1;
  border-right: 1px solid #e8eaec;
  text-align: center;
}

.item-price {
  padding-left: 10px;
  // width: 350px;
  flex: 8;
  -webkit-box-flex: 8;
}

.bjview-button {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-i {
  margin: 30px 0 auto;
  width: 200px;
}

.bjview-red {
  color: red;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform:translate(-50%,-50%);
}

.time-down {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  font-size: 14px;
  margin: 15px 0;
}

.time-down .dataing {
  font-weight: bold;
  color: #e91d1d;
  margin-right: 30px;
}

.time-down .t {
  display: flex;
  align-items: center;
  color: #232323;
  font-weight: bold;
  margin-right: 2px;
}

.time-down .t i {
  font-size: 16px;
}

.time-down .back {
  display: block;
  width: 25px;
  height: 20px;
  border-radius: 2px;
  background-color: #e91d1d;
  text-align: center;
  color: #fff;
  margin: 0 5px;
}

.message-content {
  .item:first-child {
    color: red;
    font-weight: bold;
  }
}

.red {
  color: red;
  font-weight: bold;
}

.mss-bjp .item {
  font-weight: bold;
  color: #000 !important;
}

.autoTime {
  display: flex;
  align-items: center;
}

.autoTime .back {
  display: block;
  width: 26px;
  height: 20px;
  border-radius: 2px;
  background-color: #e91d1d;
  text-align: center;
  color: #fff;
  margin: 0 5px;
}

.el-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 5px;
  box-sizing: border-box;
  padding: 10px;
  color: #828282;
  flex-direction: column
}

.zxcj {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .zxcj-box {
    display: flex;
    line-height: 39.5px;

    .bjq-numx {
      display: flex;

      .bjq-jian {}

      .bjq-shu {
        width: 50px;
        text-align: center;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
      }

      .bjq-jia {}
    }
  }
}

.mr10 {
  margin-right: 10px;
}
</style>
